import React, { useState } from 'react'
import Spinner from '../reusables/spinner';
import { Modal } from 'react-bootstrap';
import { connect } from 'react-redux';
import { activate_product, deactivate_product } from '../../redux/actions/adminActions';

function ProductModal({ show, handleClose, activate, accessToken, id, deactivate, deactivateProduct }) {


    const [isLoading,
        setIsLoading] = useState(false)

    const handleLoading = () => {
        setIsLoading(true);

        setTimeout(() => setIsLoading(false), 5000)
    }

    const handleClick = () => {
        handleLoading();
        if(deactivate){ 
            deactivateProduct(id, accessToken, handleClose());
        }else{
            activate(id, accessToken, handleClose());
        }
    }

    return (
        <Modal show={ show } onHide={ handleClose } centered>
            <div className="icon--tiny isClickable closeModal" onClick={ handleClose }>
                <i class="ri-close-line sectionText--small"></i>
            </div>
            <div className="sectionHeight--mid center">
                <div className="w-100 vAlign">
                    {deactivate ? 
                        <h2 className="sectionText--mid">Are you sure you want to deactivate { ' ' } { id.length > 1 ? 'these' : 'this' } { ' ' } product{ id.length > 1 && 's' }?</h2>
                        :
                        <h2 className="sectionText--mid">Are you sure you want to activate{ ' ' } { id.length > 1 ? 'these' : 'this' } { ' ' } product{ id.length > 1 && 's' }?</h2>
                    }

                    <div className="pt-3 center">

                        { isLoading
                            ? <div className='center'>
                                <Spinner dark />
                            </div>
                            : <div>
                                <button className="btn__filled mx-2 hasRadius" onClick={ handleClose }>No, Cancel</button>
                                <button className="btn__transparent" onClick={ handleClick }>Yes, {' '}{deactivate ? 'Deactivate' : 'Activate'}</button>
                            </div>
                        }
                    </div>
                </div>
            </div>
        </Modal>
    )
}

const mapStateToProps = (state) => ({
    accessToken: state.admin.token
})

const mapDispatchToProps = (dispatch) => ({
    activate: (data, token, success) => dispatch(activate_product(data, token, success)),
    deactivateProduct: (data, token, success) => dispatch(deactivate_product(data, token, success))
})


export default connect(mapStateToProps, mapDispatchToProps)(ProductModal)
